"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotParentBindingConstraintsWithTag = isNotParentBindingConstraintsWithTag;
const isBindingConstraintsWithTag_1 = require("./isBindingConstraintsWithTag");
const isNotParentBindingConstraints_1 = require("./isNotParentBindingConstraints");
function isNotParentBindingConstraintsWithTag(tag, value) {
    return (0, isNotParentBindingConstraints_1.isNotParentBindingConstraints)((0, isBindingConstraintsWithTag_1.isBindingConstraintsWithTag)(tag, value));
}
//# sourceMappingURL=isNotParentBindingConstraintsWithTag.js.map